import {
  bootstrapApplication,
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { importProvidersFrom } from '@angular/core';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { provideHttpClient, withFetch } from '@angular/common/http';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    importProvidersFrom(BrowserAnimationsModule),
    importProvidersFrom(
      ToastrModule.forRoot({
        positionClass: 'toast-top-right',
        preventDuplicates: true,
      })
    ),
    provideHttpClient(withFetch()),
    provideAnimations(),
    provideClientHydration(),
  ],
}).catch((err) => console.error(err));



// import {
//   bootstrapApplication,
//   provideClientHydration,
// } from '@angular/platform-browser';
// import { AppComponent } from './app/app.component';
// import { appConfig } from './app/app.config';
// import { importProvidersFrom } from '@angular/core';
// import {
//   BrowserAnimationsModule,
//   provideAnimations,
// } from '@angular/platform-browser/animations';
// import { ToastrModule } from 'ngx-toastr';
// import {
//   provideHttpClient,
//   withFetch,
//   withInterceptors
// } from '@angular/common/http';
// import { httpErrorInterceptor } from './app/Services/interceptors/http-error.interceptor'; 

// bootstrapApplication(AppComponent, {
//   ...appConfig,
//   providers: [
//     ...appConfig.providers,

//     importProvidersFrom(BrowserAnimationsModule),

//     importProvidersFrom(
//       ToastrModule.forRoot({
//         positionClass: 'toast-top-right',
//         preventDuplicates: true,
//       })
//     ),

//     provideHttpClient(
//       withFetch(),
//       withInterceptors([httpErrorInterceptor])
//     ),

//     provideAnimations(),
//     provideClientHydration(),
//   ],
// }).catch((err) => console.error(err));
